import React from 'react';

export type DemoPrivacyModeContextValue = {
  isDemoPrivacyModeEnabled: boolean;
  isDemoPrivacyModeAvailable: boolean;
  setDemoPrivacyModeEnabled: (enabled: boolean) => void;
};

export const DemoPrivacyModeContext = React.createContext<DemoPrivacyModeContextValue>({
  isDemoPrivacyModeEnabled: false,
  isDemoPrivacyModeAvailable: false,
  setDemoPrivacyModeEnabled: () => undefined,
});
